/**
 * Create sockets plugin with socket instance configuration
 *
 * @param {Object} config - Plugin configuration
 * @param {Object} config.socket - Socket instance (e.g., from useSocket() or io())
 * @returns {Function} The sockets plugin function
 *
 * @example
 * // Using with custom socket instance
 * const { socket } = useSocket();
 * const socketsPlugin = useSocketsStorePlugin({
 *   socket: socket
 * });
 *
 * @example
 * // Using with raw socket.io instance
 * import io from 'socket.io-client';
 * const socket = io('wss://example.com');
 * const socketsPlugin = useSocketsStorePlugin({ socket });
 */
export function useSocketsStorePlugin (config = {}) {
	// Extract socket from configuration
	const { socket } = config;

	if (!socket) {
		console.warn('[sockets-plugin] No socket instance provided. Plugin will not function.');
	}

	// Return the actual plugin function
	return function socketsPlugin ({ options, store }) {
		if (!options.sockets) return;

		if (!socket) {
			console.error('[sockets-plugin] Cannot setup socket listeners: no socket instance configured');
			return;
		}

		const storeName = options.name || 'store';
		const listenerCount = Object.keys(options.sockets).length;

		console.log(`🔌 [sockets-plugin] Setting up ${listenerCount} socket listener${listenerCount !== 1 ? 's' : ''} for store "${storeName}"`);

		for (const key in options.sockets) {
			socket.on(key, function (data) {
				const payload = JSON.parse(data);
				options.sockets[key].bind(store)(payload);
			});
			console.log(`   📡 Registered listener: "${key}"`);
		}
	};
}
